import React, { useState } from 'react';  
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { callAPI } from '../../hooks/CallAPI';
import { useLocalStorage } from "../../hooks/useLocalStorage";
import Loader from "../Loader";
import LoadingWrapper from '../LoadingWrapper'; // Assurez-vous que le chemin est correct
import { Download, FileText } from 'lucide-react';



// Props ajoutées: buttonTitle, className, icon
const DocumentButton = ({ filename, file_type, buttonTitle = 'Voir le PDF', className, icon = 'fa-file-pdf', loader = {} }) => {
    const [user] = useLocalStorage("user", null);
    const [isLoading, setIsLoading] = useState(false);

    // Fonction pour convertir base64 en Blob
    const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    // Modifier le type MIME basé sur le type de fichier
    const getContentType = (file_type) => {
        switch (file_type) {
            case 'pdf':
                return 'application/pdf';
            case 'png':
                return 'image/png';
            case 'jpeg':
            case 'jpg':
                return 'image/jpeg';
            default:
                return '';
        }
    };

    const handleDownload = async () => {
        setIsLoading(true); // Commencer le chargement
        try {
            const responseData = await callAPI('/document', { access_token: user.access_token, filename: filename, file_type: file_type, use_cache: false });
            if (responseData && responseData.datas) {
                const contentType = getContentType(responseData.datas.type);
                const blob = b64toBlob(responseData.datas.file, contentType);
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
                setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100); // Libérer la mémoire après un court délai
            } else {
                throw new Error(responseData.datas.msg);
            }
        } catch (error) {
            console.error('Erreur lors du téléchargement du PDF:', filename);
        } finally {
            setIsLoading(false); // Arrêter le chargement
        }
    };

     // Fonction pour afficher l'icône en fonction de la bibliothèque
     const renderIcon = () => {
        if (typeof icon === 'string') {
            // Si c'est une chaîne, on suppose que c'est une icône FontAwesome
            return <FontAwesomeIcon icon={['fas', icon]} />;
        } else if (React.isValidElement(icon)) {
            // Si c'est un élément React (comme Lucide), on l'affiche directement
            return icon;
        }
        return null;
    };

    // Utilisation des props pour le titre, la classe et l'icône
    return (
        <button onClick={handleDownload} className={`text-white font-bold relative rounded ${className}`} disabled={isLoading}>
            <LoadingWrapper isLoading={isLoading} args={loader}>
                {renderIcon()} {/* Affichage de l'icône */}
                <span className="ml-2">{buttonTitle}</span>
            </LoadingWrapper>
        </button>
    );
};

export default DocumentButton;
